// Containers
import Full from '@/containers/common/Full';

// Views
import Tms from '@/views/tms/tms';
import pic from '@/views/picture/index';
import RouterLink from '@/views/router-link/index';
import ShortUrlList from '@/views/short-url/list';
import ShortUrl from '@/views/short-url/index';
import PageTemplate from '@/views/page-template/index';
import Category from '@/views/picture/Category';
import CategoryCommon from '@/views/picture/CategoryCommon';
import PageTemplateCategoryList from '@/views/page-template/category_list';
import Fxb from '@/views/other/fxb';

import JsonContainer from '@/containers/json';
import JsonFileList from '@/views/json/file-list';
import EditJson from '@/views/json/edit-json';

import Form from '@/containers/cms/Form';
import FormList from '@/views/cms/FormList';
import AddForm from '@/views/cms/AddForm';
import FormDataList from '@/views/cms/FormDataList';

import PrdList from '@/views/prd/List';

// Views - Pages
import Page404 from '@/views/pages/Page404';
import Page500 from '@/views/pages/Page500';
import Login from '@/views/pages/Login';
import ForgetPasswd from '../views/pages/ForgetPasswd';
import Picture from '@/views/picture/h5/index.vue';

const route = [{
  path: '/',
  redirect: '/tms',
  name: '商家后台',
  component: Full,
  children: [{
    path: '/tms',
    name: 'tms首页',
    component: Tms,
    meta: {
      page_id: 1001
    }
  },
  {
    path: '/template',
    name: '页面模板',
    component: PageTemplate,
    meta: {
      page_id: 1002
    }
  },
  {
    path: '/template-category',
    name: '模板分类',
    component: PageTemplateCategoryList,
    meta: {
      page_id: 1003
    }
  },
  {
    path: 'form',
    redirect: 'form/list',
    name: '表单管理',
    component: Form,
    children: [{
      path: 'list',
      name: '表单列表',
      component: FormList,
      meta: {
        page_id: 1005
      }
    },
    {
      path: 'data/:form_id',
      name: '提交内容',
      component: FormDataList,
      meta: {
        page_id: 1006
      }
    },
    {
      path: 'add',
      name: '新增表单',
      component: AddForm,
      meta: {
        page_id: 1007
      }
    },
    {
      path: 'view',
      name: '查看表单',
      component: AddForm,
      meta: {
        page_id: 1008
      }
    }
    ]
  },
  {
    path: '/pic',
    name: '素材管理',
    component: pic,
    meta: {
      page_id: 1009
    }
  },
  {
    path: '/category',
    name: '分类管理',
    component: Category,
    meta: {
      page_id: 1010
    }
  },
  {
    path: '/categoryCommon',
    name: '分类管理',
    component: CategoryCommon,
    meta: {
      page_id: 1011
    }
  },
  {
    path: '/router-link',
    name: '页面路由管理',
    component: RouterLink,
    meta: {
      page_id: 1012
    }
  },
  {
    path: '/short-url',
    name: '短链接管理',
    component: ShortUrl,
    meta: {
      page_id: 1013
    }
  },
  {
    path: '/short-url-list',
    name: '短链接管理',
    component: ShortUrlList,
    meta: {
      page_id: 1014
    }
  },
  {
    path: 'json',
    name: 'JSON文件管理',
    redirect: 'json/list',
    component: JsonContainer,
    children: [{
      path: 'list',
      name: 'JSON文件列表',
      component: JsonFileList,
      meta: {
        page_id: 1015
      }
    },
    {
      path: 'edit/:id?',
      name: '编辑JSON文件',
      component: EditJson,
      meta: {
        page_id: 1016
      }
    }
    ]
  },
  {
    path: 'prd',
    name: '产品文档',
    redirect: 'prd/list',
    component: JsonContainer,
    children: [{
      path: 'list',
      name: '产品文档列表',
      component: PrdList,
      meta: {
        page_id: 1017
      }
    }]
  }
  ]
},
{
  path: '/pages',
  redirect: '/pages/404',
  name: 'Pages',
  component: {
    render(c) {
      return c('router-view');
    }
  },
  children: [{
    path: '404',
    name: 'Page404',
    component: Page404
  },
  {
    path: '500',
    name: 'Page500',
    component: Page500
  },
  {
    path: 'login',
    name: 'Login',
    component: Login
  },
  {
    path: '/h5-pic',
    name: 'yytools h5图片',
    component: Picture,
  },
  {
    path: 'modifypasswd',
    name: 'ForgetPasswd',
    component: ForgetPasswd
  },
  {
    path: 'fxb',
    name: '分销宝',
    component: Fxb,
  },
  ]
}
  // {
  //   path: '*',
  //   redirect: { path: '/' },
  // },
];

export default route;
